import OnboardingType from "../../../../../shared/onboarding/onboarding-type";
import overview from "../../../../icons/overview";
import { FETCH_SHOTS_OVERVIEW, REORDER_SHOTS_ORDER, SAVE_SHOTS_ORDER, UPLOAD_SHOTS, DELETE_MULTIPLE_SHOTS } from "./actions";

interface CharacterOverviewState {
  overview: any;
  loading: boolean;
  saveing: boolean;
  readOnly: boolean;
  pristine: boolean;
  errors: any;
  shotsOnboardingSteps: OnboardingType[];
  isUploading: boolean;
  deleteing: boolean;
}

export const OnboardingStep1ClassName = 'shots-overview-onboarding-step-1';
export const OnboardingStep2ClassName = 'shots-overview-onboarding-step-2';
export const OnboardingStep3ClassName = 'shots-overview-onboarding-step-3';
export const OnboardingStep4ClassName = 'shots-overview-onboarding-step-4';

const defaultState: CharacterOverviewState = {
  overview: {},
  loading: true,
  readOnly: false,
  saveing: false,
  pristine: true,
  isUploading: false,
  errors: null,
  deleteing: false,
  shotsOnboardingSteps: [
    {
      target: '.' + OnboardingStep1ClassName,
      title: 'Re-order shots',
      content: `Drag and drop shots to change the order.`
    },
    {
      target: '.' + OnboardingStep2ClassName,
      title: 'Save',
      content: `Once the shots are in the desired order, then click Save.`
    }
  ]
};

const reducer = (state = defaultState, action: any = {}) => {
  switch (action.type) {
    case FETCH_SHOTS_OVERVIEW + "_PENDING": {
      return {
        ...state,
        loading: true,
        overview: null,
        errors: null,
        pristine: true
      };
    }

    case FETCH_SHOTS_OVERVIEW + "_FULFILLED": {
      return {
        ...state,
        loading: false,
        overview: action.payload.data,
        errors: null
      };
    }

    case SAVE_SHOTS_ORDER + "_PENDING": {
      return {
        ...state,
        saving: true
      };
    }

    case SAVE_SHOTS_ORDER + "_FULFILLED": {
      return {
        ...state,
        saving: false,
        pristine: true
      };
    }

    case SAVE_SHOTS_ORDER + "_REJECTED": {
      return {
        ...state,
        errors: action.payload.response.data.errors,
        saving: false
      };
    }

    case REORDER_SHOTS_ORDER: {
      let shots = Array.from(state.overview.shots);
      shots = reorderShots(
        shots,
        action.meta.startIndex,
        action.meta.endIndex
      );

      return {
        ...state,
        overview: { ...state.overview, shots },
        pristine: false
      };
    }

    case DELETE_MULTIPLE_SHOTS + "_PENDING": {
      return {
        ...state,
        deleteing: true
      };
    }

    case DELETE_MULTIPLE_SHOTS + "_FULFILLED": {
      const updatedData = action.payload.data.shots;
      const deletedIds = action.meta.shotIds;

      // Filter out deleted shots and merge updated numbers
      const mergedShots = state.overview.shots
        .filter((shot: any) => !deletedIds.includes(shot.id))
        .map((shot: any) => {
          const updated = updatedData.find((u: any) => u.id === shot.id);
          return updated ? { ...shot, number: updated.number } : shot;
        });

      return {
        ...state,
        deleteing: false,
        overview: { ...state.overview, shots: mergedShots }
      };
    }

    case DELETE_MULTIPLE_SHOTS + "_REJECTED": {

      return {
        ...state,
        deleteing: false,
        errors: action.payload.response.data.errors,
      };
    }

    default:
      return state;
  }
};

const reorderShots = (list, sourceIndex, destinationIndex) => {
  const result: any[] = Array.from(list);
  result[sourceIndex].number = destinationIndex + 1;

  if (sourceIndex > destinationIndex) {
    for (let i = destinationIndex; i < sourceIndex; i++) {
      result[i].number++;
    }
  }

  if (sourceIndex < destinationIndex) {
    for (let i = sourceIndex + 1; i <= destinationIndex; i++) {
      result[i].number--;
    }
  }

  const [removed] = result.splice(sourceIndex, 1);
  result.splice(destinationIndex, 0, removed);

  return result;
};

export default reducer;
